import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Select,
  MenuItem,
  InputAdornment,
  Button,
  Chip,
  Typography,
  FormControl,
  InputLabel,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Stack, TableFooter
} from '@mui/material';
import {
  Search as SearchIcon,
  Storefront as StorefrontIcon,
  Download as DownloadIcon,
  PictureAsPdf as PdfIcon,
  TableChart as ExcelIcon,
  ReceiptLong as ReceiptIcon,
  Summarize as SummaryIcon,
  Clear,
  Print as PrintIcon
} from '@mui/icons-material';
import { getGSTReportDataDetailView, getGSTReportDataSummaryView, downloadExcelSheetGSTReportDetailData, downloadPDFGetGSTReportDetailReport,downloadExcelSheetGSTReportSummaryData,downloadPDFGetGSTReportSummaryReport } from '../services/reportService'
import outletService from '../services/outletService';
import { useNotification } from '../contexts/NotificationContext';

function GSTReportManagement() {
  const { showSuccess, showError } = useNotification()
  const [view, setView] = useState('summary'); // 'summary' or 'details'
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedOutlet, setSelectedOutlet] = useState('all');
  const [loading, setLoading] = useState(false);
  const [downloadingPDF, setDownloadingPDF] = useState(false);
  const [downloadingExcel, setDownloadingExcel] = useState(false);


  // Summary View State
  const [summaryData, setSummaryData] = useState([]);
  const [summaryTotals, setSummaryTotals] = useState({
    total_taxable_sales: 0,
    total_output_gst: 0,
    total_net_gst: 0
  });

  // Details View State
  const [detailsData, setDetailsData] = useState([]);
  const [detailsSummary, setDetailsSummary] = useState({
    total_orders: 0,
    subtotal_total: 0,
    tax_total: 0,
    service_charge_total: 0,
    grand_total: 0
  });
  const [pagination, setPagination] = useState({
    page: 0,
    limit: 5,
    total: 0,
    pages: 0
  });

  // Search filters for details view
  const [searchOrderNo, setSearchOrderNo] = useState('');
  const [searchCustomer, setSearchCustomer] = useState('');
  const [searchOutlet, setSearchOutlet] = useState('all');
  const [searchType, setSearchType] = useState('all'); // 'all', 'dine-in', 'takeaway', etc.
  const [outlets, setOutlets] = useState([])
  const [orderType, setOrderType] = useState(null)
  const [clearFilterShow, setClearFilterShow] = useState(false)
  
  function checkFilter() {
      return searchOrderNo === '' && searchCustomer === '' && searchOutlet === "" && searchType === null && orderType === null && startDate === "" && endDate === "" && selectedOutlet === "all"
  }
  

  // Get today's date in YYYY-MM-DD format
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  //   useEffect(() => {
  //     // Set default date range
  //     setStartDate(getTodayDate());
  //     setEndDate(getTodayDate());
  //   }, []);

  useEffect(() => {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    // Get previous month
    let prevMonth = currentMonth - 1;
    let prevMonthYear = currentYear;

    // Handle January (0) case - previous month is December of previous year
    if (prevMonth < 0) {
      prevMonth = 11; // December
      prevMonthYear = currentYear - 1;
    }

    // Get first day of previous month
    const firstDay = new Date(prevMonthYear, prevMonth, 1);

    // Get last day of previous month
    const lastDay = new Date(prevMonthYear, prevMonth + 1, 0);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    setStartDate(formatDate(firstDay));
    setEndDate(formatDate(lastDay));
  }, []);

  useEffect(() => {
    fetchSummaryData();
    fetchOutlets();
    if(JSON.parse(localStorage.getItem("admin_outlet_id"))){
      setSelectedOutlet(JSON.parse(localStorage.getItem("admin_outlet_id")))
    }
    // if (!checkFilter()) {
    //   setClearFilterShow(true)
    // }
  }, [selectedOutlet, startDate,endDate]);

  useEffect(() => {
    if (view === 'details') {
      fetchDetailsData();
    }
    if (!checkFilter()) {
      setClearFilterShow(true)
    }
  }, [view, selectedOutlet, endDate, searchOrderNo, searchCustomer, searchOutlet, searchType, pagination.page, pagination.limit]);

  const fetchOutlets = async () => {
    try {
      const response = await outletService.getOutlets();
      setOutlets(response)
    }
    catch (error) {
      console.error("Error While Getting Outlets ", error)
    }
  }


  const fetchSummaryData = async () => {
    setLoading(true);
    try {
      // Simulate API call
      const response = await getGSTReportDataSummaryView(selectedOutlet, startDate, endDate);
      // Filter data based on outlet selection
      // console.log("Response Message =>", response.message)
      let filteredData = response.message;

      // if (selectedOutlet !== 'all') {
      //   filteredData = filteredData.filter(item => item.outlet_id === parseInt(selectedOutlet));
      // }

      setSummaryData(filteredData);

      // Calculate totals
      // const totals = filteredData.reduce((acc, item) => ({
      //   total_taxable_sales: acc.total_taxable_sales + item.total_subtotal,
      //   total_output_gst: acc.total_output_gst + item.total_tax,
      //   net_gst_total: acc.total_net_gst + item.total_tax
      // }), { total_taxable_sales: 0, total_output_gst: 0, total_net_gst: 0 });

      setSummaryTotals(response.overall);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching summary data:", error);
      setLoading(false);
    }
  };

  const fetchDetailsData = async () => {
    setLoading(true);
    try {
      // Simulate API call
      const detail_response = await getGSTReportDataDetailView(selectedOutlet, startDate, endDate, pagination.page, pagination.limit, searchType)

      let filteredData = [...detail_response.result];
      //   setPagination({
      //     ...pagination,
      //     pages:detail_response.pagination.pages 
      //   });
      // Apply filters
      //   if (selectedOutlet !== 'all') {
      //     const outletName = mockOutlets.find(o => o.id === parseInt(selectedOutlet))?.name;
      //     if (outletName) {
      //       filteredData = filteredData.filter(item => item.outlet === outletName);
      //     }
      //   }

      if (searchOrderNo) {
        filteredData = filteredData.filter(item =>
          item.order_number.toLowerCase().includes(searchOrderNo.toLowerCase())
        );
      }

      if (searchCustomer) {
        filteredData = filteredData.filter(item =>
          item.customer_name.toLowerCase().includes(searchCustomer.toLowerCase())
        );
      }

      // if (searchOutlet !== 'all') {
      //   const outletName = mockOutlets.find(o => o.id === parseInt(searchOutlet))?.name;
      //   if (outletName) {
      //     filteredData = filteredData.filter(item => item.outlet === outletName);
      //   }
      // }

      // Apply pagination
      const { page, limit } = pagination;
      //   const start = page * limit;
      //   const end = start + limit;
      const paginatedData = filteredData
      // console.log("Paginated Data => ", paginatedData)
      setDetailsData(paginatedData);
      // setDetailsSummary(mockDetailsData.summary);
      setPagination({
        ...pagination,
        total: detail_response.pagination.total,
        pages: detail_response.pagination.pages
      });
      setLoading(false);

    } catch (error) {
      console.error("Error fetching details data:", error);
      setLoading(false);
    }
  };

  const handleViewChange = (event) => {
    setView(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPagination({ ...pagination, page: newPage });
  };

  const handleRowsPerPageChange = (event) => {
    setPagination({
      ...pagination,
      limit: parseInt(event.target.value, 10),
      page: 0
    });
  };

  const handleClearFilters = () => {
    setStartDate('');
    setEndDate('');
    setSelectedOutlet('all');
    setSearchOrderNo('');
    setSearchCustomer('');
    setSearchOutlet('all');
    setSearchType('all');
    setClearFilterShow(false)
  };

  const handleExportPDF = async () => {
    setDownloadingPDF(true);
    try {
      // Simulate PDF download
      // await new Promise(resolve => setTimeout(resolve, 1500));
      if (view === "details"){
         const response = await downloadPDFGetGSTReportDetailReport(selectedOutlet, startDate, endDate, searchType)
      }
      else{
        const response = await downloadPDFGetGSTReportSummaryReport(selectedOutlet, startDate, endDate, searchType)
      }
      showSuccess("PDF Downloaded Successfully")
    } catch (error) {
      console.error("Error downloading PDF:", error);
    } finally {
      setDownloadingPDF(false);
    }
  };

  const handleExportExcel = async () => {
    setDownloadingExcel(true);
    try {
      // Simulate Excel download
      if(view === "details"){
        downloadExcelSheetGSTReportDetailData(selectedOutlet, startDate, endDate, searchType);
      }
      else{
        downloadExcelSheetGSTReportSummaryData(selectedOutlet, startDate, endDate, searchType);
      }
      
      showSuccess("Excel Downloaded Successfully")
      // alert('Excel downloaded successfully!');
    } catch (error) {
      console.error("Error downloading Excel:", error);
    } finally {
      setDownloadingExcel(false);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  // Common filters component
  const FiltersSection = () => (
    <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
      <Grid item xs={12} md={2.5}>
        <TextField
          fullWidth
          size="small"
          type="date"
          label="Start Date"
          value={startDate}
          onChange={(e) => {
            const newStartDate = e.target.value;
            setStartDate(newStartDate);
            // Clear end date if it's before the new start date
            if (endDate && newStartDate > endDate) {
              setEndDate('');
            }
          }}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            max: endDate || undefined, // Can't select start date after end date
            max: new Date().toISOString().split('T')[0] // Can't select future dates (optional)
          }}
        />
      </Grid>
      <Grid item xs={12} md={2.5}>
        <TextField
          fullWidth
          size="small"
          type="date"
          label="End Date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            min: startDate || undefined, // Can't select end date before start date
            max: new Date().toISOString().split('T')[0] // Can't select future dates (optional)
          }}
          disabled={!startDate} // End date is disabled until start date is selected
        />
      </Grid>
      <Grid item xs={12} md={2.5}>
        <FormControl fullWidth size="small">
          <InputLabel>Outlet</InputLabel>
          <Select
            value={selectedOutlet}
            disabled={JSON.parse(localStorage.getItem('admin_outlet_id')) ? true : false}
            label="Outlet"
            onChange={(e) => setSelectedOutlet(e.target.value)}
            startAdornment={
              <InputAdornment position="start">
                <StorefrontIcon fontSize="small" />
              </InputAdornment>
            }
          >
            <MenuItem value="all">All Outlets</MenuItem>
            {outlets.map((outlet) => (
              <MenuItem key={outlet.id} value={outlet.id}>{outlet.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    
      {/* {clearFilterShow && */}
      <Grid item xs={12} md={2.5}>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<Clear />}
          onClick={handleClearFilters}
          sx={{ height: '40px' }}
        >
          Clear Filters
        </Button>
      </Grid> 
      {/* } */}
    </Grid>
  );

  // Summary View
  const renderSummaryView = () => (
    <>
      {/* Summary Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={4}>
          <Card sx={{ bgcolor: '#E2E8F0', borderRadius: '8px', mb: 2 }}>
            <CardContent>
              <Typography color="text.secondary" variant="subtitle2" gutterBottom>
                Total Taxable Sales
              </Typography>
              <Typography variant="h4" fontWeight="bold">
                S$ {summaryTotals.total_taxable_sales}
              </Typography>
              {/* <Typography variant="caption" color="text.secondary">
                Total sales (Taxable)
              </Typography> */}
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ bgcolor: '#e8f5e9', borderRadius: '8px' }}>
            <CardContent>
              <Typography color="text.secondary" variant="subtitle2" gutterBottom>
                Total Output GST
              </Typography>
              <Typography variant="h4" fontWeight="bold" sx={{ color: '#2e7d32' }}>
                S$ {summaryTotals.total_output_gst}
              </Typography>
              {/* <Typography variant="caption" color="text.secondary">
                Total Output GST (9%)
              </Typography> */}
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ bgcolor: '#fff3e0', borderRadius: '8px' }}>
            <CardContent>
              <Typography color="text.secondary" variant="subtitle2" gutterBottom>
                Total Amount
              </Typography>
              <Typography variant="h4" fontWeight="bold" sx={{ color: '#ed6c02' }}>
                S$ {summaryTotals.net_gst_total}
              </Typography>
              {/* <Typography variant="caption" color="text.secondary">
                Output GST Payable
              </Typography> */}
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Summary Table */}
      <Paper sx={{ width: '100%', overflow: 'hidden', borderRadius: '8px' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: 'grey.50' }}>
                <TableCell><Typography variant="subtitle2" fontWeight="bold">S.NO</Typography></TableCell>
                <TableCell><Typography variant="subtitle2" fontWeight="bold">Outlet Name</Typography></TableCell>
                <TableCell><Typography variant="subtitle2" fontWeight="bold">Outlet Code</Typography></TableCell>
                <TableCell align="right"><Typography variant="subtitle2" fontWeight="bold">Taxable Sales (S$)</Typography></TableCell>
                <TableCell align="center"><Typography variant="subtitle2" fontWeight="bold">GST %</Typography></TableCell>
                <TableCell align="right"><Typography variant="subtitle2" fontWeight="bold">Output GST (S$)</Typography></TableCell>
                <TableCell align="right"><Typography variant="subtitle2" fontWeight="bold">Total Amount (S$)</Typography></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : summaryData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                    <Typography color="text.secondary">No data found</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                summaryData.map((item, index) => (
                  <TableRow key={item.outlet_id} hover>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{item.outlet_name}</TableCell>
                    <TableCell>
                      <Chip
                        label={item?.outlet_uen}
                        size="small"
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: 500 }}>
                      {item?.total_subtotal}
                    </TableCell>
                    <TableCell align="center"> {item?.outlet_tax}%</TableCell>
                    <TableCell align="right" sx={{ color: '#2e7d32' }}>
                      {item?.total_tax}
                    </TableCell>
                    <TableCell align="right" sx={{ color: '#ed6c02', fontWeight: 500 }}>
                      {item?.total_price}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
            {summaryData.length > 0 && (
              <TableFooter>
                <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                  <TableCell colSpan={3}><Typography fontWeight="bold">GRAND TOTAL</Typography></TableCell>
                  <TableCell align="right"><Typography fontWeight="bold">S$ {summaryTotals.total_taxable_sales}</Typography></TableCell>
                  <TableCell></TableCell>
                  <TableCell align="right"><Typography fontWeight="bold">S$ {summaryTotals.total_output_gst}</Typography></TableCell>
                  <TableCell align="right"><Typography fontWeight="bold">S$ {summaryTotals.net_gst_total}</Typography></TableCell>
                </TableRow>
              </TableFooter>
            )}
          </Table>
        </TableContainer>
      </Paper>

      <Box sx={{ mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: '8px' }}>
        <Typography variant="body2" color="text.secondary">
          This report shows the GST collected (Output GST) from sales across all selected outlets.
        </Typography>
      </Box>
    </>
  );

  // Details View
  const renderDetailsView = () => (
    <>
      {/* Details Summary Cards */}
      {/* <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ bgcolor: '#e3f2fd', borderRadius: '8px' }}>
            <CardContent>
              <Typography variant="caption" color="text.secondary">Total Orders</Typography>
              <Typography variant="h5" fontWeight="bold">{detailsSummary.total_orders}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ bgcolor: '#e8f5e9', borderRadius: '8px' }}>
            <CardContent>
              <Typography variant="caption" color="text.secondary">Subtotal Total</Typography>
              <Typography variant="h5" fontWeight="bold" sx={{ color: '#2e7d32' }}>
                S$ {detailsSummary.subtotal_total?.toFixed(2)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ bgcolor: '#fff3e0', borderRadius: '8px' }}>
            <CardContent>
              <Typography variant="caption" color="text.secondary">Tax Total</Typography>
              <Typography variant="h5" fontWeight="bold" sx={{ color: '#ed6c02' }}>
                S$ {detailsSummary.tax_total?.toFixed(2)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ bgcolor: '#f3e5f5', borderRadius: '8px' }}>
            <CardContent>
              <Typography variant="caption" color="text.secondary">Grand Total</Typography>
              <Typography variant="h5" fontWeight="bold" sx={{ color: '#9c27b0' }}>
                S$ {detailsSummary.grand_total?.toFixed(2)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid> */}

      {/* Details Search Filters */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} md={2.5}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search Order No..."
            value={searchOrderNo}
            onChange={(e) => setSearchOrderNo(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={12} md={2.5}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search Customer..."
            value={searchCustomer}
            onChange={(e) => setSearchCustomer(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        {/* <Grid item xs={12} md={2.5}>
          <FormControl fullWidth size="small">
            <InputLabel>Outlet</InputLabel>
            <Select
              value={searchOutlet}
              label="Outlet"
              onChange={(e) => setSearchOutlet(e.target.value)}
            >
              <MenuItem value="all">All Outlets</MenuItem>
              {mockOutlets.map((outlet) => (
                <MenuItem key={outlet.id} value={outlet.id}>{outlet.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}
        <Grid item xs={12} md={2.5}>
          <FormControl fullWidth size="small">
            <InputLabel>Type</InputLabel>
            <Select
              value={searchType}
              label="Type"
              onChange={(e) => {
                setPagination({
                  page: 0,
                  limit: 5,
                  total: 0,
                  pages: 0
                })
                setSearchType(e.target.value)
              }}
            >
              <MenuItem value="all">All Types</MenuItem>
              <MenuItem value="dine_in">Dine In</MenuItem>
              <MenuItem value="takeaway">Takeaway</MenuItem>
              <MenuItem value="delivery">Delivery</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      {/* Details Table */}
      <Paper sx={{ width: '100%', overflow: 'hidden', borderRadius: '8px' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: 'grey.50' }}>
                <TableCell><Typography variant="subtitle2" fontWeight="bold">#</Typography></TableCell>
                <TableCell><Typography variant="subtitle2" fontWeight="bold">Date</Typography></TableCell>
                <TableCell><Typography variant="subtitle2" fontWeight="bold">Outlet</Typography></TableCell>
                <TableCell><Typography variant="subtitle2" fontWeight="bold">Order Number</Typography></TableCell>
                <TableCell><Typography variant="subtitle2" fontWeight="bold">Customer</Typography></TableCell>
                <TableCell><Typography variant="subtitle2" fontWeight="bold">Order Type</Typography></TableCell>
                <TableCell align="right"><Typography variant="subtitle2" fontWeight="bold">Gross Amount</Typography></TableCell>
                <TableCell align="right"><Typography variant="subtitle2" fontWeight="bold">GST</Typography></TableCell>
                <TableCell align="right"><Typography variant="subtitle2" fontWeight="bold">Service Charge</Typography></TableCell>
                <TableCell align="right"><Typography variant="subtitle2" fontWeight="bold">Net Amount</Typography></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : detailsData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                    <Typography color="text.secondary">No data found</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                detailsData.map((item, index) => (
                  <TableRow key={index} hover>
                    <TableCell>{pagination.page * pagination.limit + index + 1}</TableCell>
                    <TableCell>{item.date}</TableCell>
                    <TableCell>
                      <Chip label={item.outlet} size="small" variant="outlined" />
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" fontWeight="500">
                        {item.order_number}
                      </Typography>
                    </TableCell>
                    <TableCell>{item.customer_name}</TableCell>
                    <TableCell>{item.order_type}</TableCell>
                    <TableCell align="right">S$ {item.gross_amount}</TableCell>
                    <TableCell align="right" sx={{ color: '#2e7d32' }}>
                      S$ {item.gst}
                    </TableCell>
                    <TableCell align="right">S$ {item.service_charge}</TableCell>
                    <TableCell align="right" sx={{ fontWeight: 500, color: '#1976d2' }}>
                      S$ {item.net_amount}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={pagination.total}
          rowsPerPage={pagination.limit}
          page={pagination.page}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
        />
      </Paper>
    </>
  );

  return (
    <Box sx={{ width: '100%', p: 3 }}>
      {/* Header */}
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap' }}>
        <Box>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            GST Report
          </Typography>
          <Typography color="text.secondary" variant="body1">
            Summary of GST collected from all outlets.
          </Typography>
        </Box>

        {/* Export Buttons */}
        <Stack direction="row" spacing={1} sx={{ mt: { xs: 2, md: 0 } }}>
            <Button
            variant="contained"
            size="small"
            startIcon={downloadingExcel ? <CircularProgress size={16} /> : <ExcelIcon />}
            onClick={handleExportExcel}
            disabled={downloadingExcel}
          // sx={{ borderColor: '#4caf50', color: '#4caf50' }}
          >
            Download Excel
          </Button>
          <Button
            variant="contained"
            size="small"
            startIcon={downloadingPDF ? <CircularProgress size={16} /> : <PdfIcon />}
            onClick={handleExportPDF}
            disabled={downloadingPDF}
          // sx={{ borderColor: '#f44336', color: '#f44336' }}
          >
            Download PDF
          </Button>
        
          {/* <Button
            variant="outlined"
            size="small"
            startIcon={<PrintIcon />}
            onClick={handlePrint}
          >
            Print
          </Button> */}
        </Stack>
      </Box>

      {/* View Toggle - Radio Buttons */}
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 3 }}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            value={view}
            onChange={handleViewChange}
          >
            <FormControlLabel
              value="summary"
              control={<Radio />}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <SummaryIcon fontSize="small" />
                  <span>Summary View</span>
                </Box>
              }
            />
            <FormControlLabel
              value="details"
              control={<Radio />}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <ReceiptIcon fontSize="small" />
                  <span>Detailed View</span>
                </Box>
              }
            />
          </RadioGroup>
        </FormControl>

        {/* <Chip 
          label={view === 'summary' ? `${summaryData.length} Outlets` : `${pagination.total} Transactions`}
          size="small"
          color="primary"
          variant="outlined"
        /> */}
      </Box>

      {/* Common Filters */}
      <FiltersSection />

      <Divider sx={{ mb: 3 }} />

      {/* Render View */}
      {view === 'summary' ? renderSummaryView() : renderDetailsView()}
    </Box>
  );
}

export default GSTReportManagement;